<template>
    <!-- <section class="section-hero  cto-founder courses-hero"> -->
    <section class="section-hero" style="padding-bottom: 0.5rem;">
      <div class="hero container">
        <div class="hero-content">
            <h1 class="heading-primary">{{$t('Understanding Options')}}</h1>
            
                 <div class="founder-avatar">
                        <img :src="course.iconUrl"  style="width:45rem;border-radius:16px;"/>
                        
                    </div>
                <div class="section-header">
                   
                    <h2 class="heading-secondary">
                      <!-- {{getShortDesc(course)}} -->
                
               
                    </h2>
                   
                </div>

                 <section class="home-education">
                  <div class="container section-value-props section-education hidden">
                    <div class="section-header">
                      
                      
                      <Card>
                         <!-- <template #header>
                          <img alt="user header" src="/assets/qtrade-logoon-white.jpeg" style="max-width:25rem;"/> 
                          </template> -->
                        <template #title>
                            {{$t('Course Overview')}}
                        </template>
                        <template #content>
                          <p class="value-description">
                              Options trading can be profitable, but only if you truly understand how options work, what the risks are and the strategies used to mitigate those risks.   
                              Without a firm grasp of these concepts, trading options can quickly lose you a lot of money.
                              This course was written by a CFA and is designed to give you a thorough hands on education about options and option trading strategies.
                  
                          </p>
                          <div class="course-outline">
                            <p class="value-description">Here's brief outline of what's covered in the course:</p>
                          <p class="value-description">
                              <ul class="course-outline-list value-description">
                                <li>Module 1: What options are, how they work, basic terminology, Profit Profiles.</li>
                                <li>Module 2: Intrinsic and Extrinsic Value, Time Decay, Volatility, Greeks.</li>
                                <li>Module 3: Beginner Strategies, Individual Trades, Spreads, Collars, Straddles, Strangles.</li>
                                <li>Module 4: Intermediate/Advanced Strategies, Iron Condor, Iron Butterfly, Calendar Spreads, Diagonal Spreads, Ratio Spreads, Rolling Options.</li>
                                <li>Module 5: Choosing Strategies that are right for you.</li>
                                
                              </ul>

                          </p>
                          </div>
                          <div>
                           <p class="value-description">
                            <br>
                            With access to our Options tools you can practice options trading in a <b>risk-free</b> environment.
                            </p>

                          </div>

                          
                          
                         



                          <div  class="course-vid-container">
                            <div class="video-text">{{ $t('Watch the video to get a more detailed overview of the course.')}}</div>
                          
                            <video class="course-vid" controls :poster="course.poster">
                                <source
                                    :src="course.video"
                                    type="video/mp4" />
                            </video>  
                            
                          </div>
                          <br>
                          <div class="pricing-header" >
                            <div class="course-pricing-cont">
                              <span class="course-price-label">{{$t('Price')}}:</span>
                              <div class="course-pricing">
                                <span class="course-price">{{course.cdnPrice}} CAD</span>
                                
                                
                              
                              </div>
                              
                            </div>
                          </div>
                          <div class="pricing-header" >
                             <div class="course-pricing-cont">
                              <div class="course-pricing">
                              <span>(Free for <a href="/pricing">Premium Plus subscribers</a>!)</span>
                              </div>
                            </div>
                            
                            
                          </div>
                           <a class="cta btn"   @click="goToSignup()" >{{$t('Sign Up')}}</a>
                           <br><br>
                          <div class="section-header">
                            <template v-if="i18nService.currentLocale == 'fr'">
                                <p class="signup-free value-description"><a style="cursor:pointer;" @click="goToSignup()">L'inscription est gratuite</a> (aucune carte de crédit requise). Une fois que vous avez un compte, vous pouvez prévisualiser ou acheter n'importe lequel de nos cours.</p>
                              </template>
                                
                              <template v-else>
                               <p class="signup-free value-description">It's free to <a style="cursor:pointer;" @click="goToSignup()">signup for an account</a> (no cc required). </p>
                              <p class="signup-free value-description">Once you have an account you can then purchase this course.</p>
                              <p class="signup-free value-description"><b>OR</b></p>
                               <p class="signup-free value-description">Purchase a <a href="/pricing">Premium Plus subscription</a> and get access to <b>all</b> of our <a href="/courses">courses</a> <br>and unlimited access to all our research tools and data.</p>
                             
                              </template>
                          </div>
                        </template>
                       </Card>
                    </div>
                    
                    
                  </div>
                </section>
                
                
              
            
            
            
        </div>
      </div>
    </section>
    
  </template>
  
  <script>
import { SIGNUP_URL, QTRADE_REF_ON } from "../config.js";
//import DataView from "primevue/dataview";
import Card from "primevue/card";
//import Button from "primevue/button";


//import CourseInfoModal from '../components/education/CourseInfoModal.vue';
import i18nService from '../i18n.js';

  export default {
    name: "UnderstandingOptions",

    components: {
       // Avatar
      // DataView,
       //CourseInfoModal,
       Card,
      // Button,
    
    },
    head() {
      return {
        title: "INVRS - Understanding Options",
        meta:[
          { 
            name: "description",
            content: 'Obtain an in depth understanding of options: how they work, risks and pitfalls, strategies.'
          },
          { 
            name: "twitter:title",
            content: 'INVRS - Understanding Options'
          },
          { 
            name: "twitter:description",
            content: 'Obtain an in depth understanding of options: how they work, risks and pitfalls, strategies.'
          },
          { 
            name: "og:title",
            content: 'INVRS - Understanding Options'
          },
          { 
            name: "og:description",
            content: 'Obtain an in depth understanding of options: how they work, risks and pitfalls, strategies.'
          },
        ]
      }
    },

    data() {
      return {
         i18nService,
        heroSection: "",
        heroContent: "",
        ceoFounder: "",
        ctoFounder: "",
        ceoFounderImagePath: "../../assets/ceo-founder.jpg",
        obsOptionsHero: {
          root: null,
          threshold: 0.1,
        },
        course:
          { 
            name: this.$t("Understanding Options"), 
            shortDescription: {
              en: "Obtain an in depth understanding of options: how they work, risks and pitfalls, strategies.", 
              fr: "Acquérez une compréhension approfondie des options : leur fonctionnement, leurs risques et leurs pièges, les stratégies à adopter."
            },
            description: {
              en: `Obtain an in depth understanding of options: how they work, risks and pitfalls, strategies. Practice option investing in a risk-free environment.`,
              fr: `Acquérez une compréhension approfondie des options : leur fonctionnement, leurs risques et leurs pièges, les stratégies. Entraînez-vous à investir dans des options dans un environnement sans risque.`
            },
            iconUrl: "/assets/options-300x175.png",
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'options',
            langs: ['eng'],
            video: 'https://docs.invrs.com/public/UnderstandingOption-Overview-comp.mp4',
            poster: 'https://docs.invrs.com/public/optionsOverviewThumb.png'
           
            
            
          },
           

       

       
       

        
      };
    },
    mounted() {
     console.log("current locale "+ i18nService.currentLocale)
    },
    methods: {

      isQTradeOn() {
        return QTRADE_REF_ON;
      },

      openCourseInfo(course) {
        this.$refs.courseInfoModal.open(course);
      },

      revealFounders() {
        //this.ceoFounder.classList.remove("hidden-founder");
        this.ctoFounder.classList.remove("hidden-founder");
      },
      revealHero() {
        this.revealFounders();
      },
      goToSignup() {
        //evt.preventDefault();
        window.location.href = SIGNUP_URL+"?courseCode="+this.course.signupCode;
       

        
      },
      getShortDesc(course){
        return course.shortDescription[i18nService.currentLocale];
      }
    },
  };
  </script>
  
  <style scoped>

    .course-outline{
      margin-top: 1rem;
      margin-left:auto;
      margin-right:auto;
      text-align: left;
    }

    .course-outline-list{
      padding-inline-start: revert;
    }

    .video-text{
      margin: 1rem auto 1rem auto;
      font-size: 1.8rem;
  }
.course-vid {
    width: 100%; 
}
.course-vid-container{
    text-align: center;
    width: 100%;
    display:flex;
      flex-direction: column;
      margin-top:5px;
      /*max-width: 30rem;*/
      align-items: baseline;
      align-self: flex-end;
      justify-content: end;

}
    .course-line{
      
    }

    .course-div{
      /*min-width:20rem;*/
    }
    ::v-deep(.emph){
      text-decoration: underline;
    }
    ::v-deep(.p-card .p-card-title){
      font-size: 2rem;
    }

    ::v-deep(.p-card-content){
      font-size: 2rem;
    }

    .course-info{
      display:flex;
      flex-direction:column;
      height:100%;
      min-height:100%;
      padding:5px;
    }
    .course-desc-cont{
      flex-grow: 1;
    }
    .course-box{
      display:flex;
      height:100%;
      cursor: pointer;
      flex-direction:row;
    }

    .course-img {
      max-width: 25rem;
      max-height: 25rem;
      margin-top: 1rem;
    }
    .course-price-label{
      font-size: 1.8rem;
      margin-right:auto;
    }

    .course-price{
      font-size: 1.8rem;
     
    }
    .course-pricing{
      display:flex;
      flex-direction: column;
      
      margin-left:5px;
      align-items: end;
    }
    .course-pricing-cont{
      display:flex;
      flex-direction: row;
      
      
      align-items: end;
      
    }

     .pricing-header{
      display:flex;
      flex-direction: row;
      margin-top:5px;
      /*max-width: 30rem;*/
      align-items: baseline;
      align-self: flex-end;
      justify-content: center;
    }

  .more-info{
    cursor:pointer;
    color:#33cc99;
    font-size: 1.2rem;
  }

  a.cta{
    padding: .8rem 1.3rem;
    align-self: center;
    margin-left:auto;
    font-size: 1.5rem;
    margin-top: 1rem;
  }

    .custom-text {
      padding-bottom:5rem;
    }
    .custom-section{
      align-items: center;
    }
    .custom-course-img{
      max-width:45rem;
    }
    .value-description{
      margin-bottom: 0;
    }

    .value-description {
    font-size: 1.5rem;
    line-height: 2.6rem;
  }

    .heading-course-cat {
      font-size: 3.2rem;
      color: #333;
      margin-bottom: 2.8rem;
      line-height: 1.1;
    }

   .courses-header{
      flex-direction: column;
   }

  .grid--2-cols {
      grid-template-columns: repeat(2, 1fr);
  }

  .key-points{
    margin-top:2rem;
  }

  .section-hero {
    position: relative;
    padding: 12.8rem 0 9.6rem 0;
    
  }
  
  .hero-content {
    max-width: 130rem;
    margin: 0 auto;
    padding: 0 3.6rem;
  }

  .heading-primary {
    margin-bottom: 3.8rem;
  }

  .hidden-founder {
    opacity: 0;
  }
  .hidden-content {
    transform: translateX(-9.6rem);
    opacity: 0;
  }
  .hidden-founder.ceo-founder {
    transform: translateX(-9.6rem);
  }

  .main-section {
    display: flex;
    align-items: flex-start;
    margin-bottom: 5rem;
    transition: all 0.6s ease-in;
    padding-left: 11rem;
  }

  .hero-founder {
    display: flex;
    align-items: center;
    margin-bottom: 3rem;
    margin-top: 3rem;
    transition: all 0.6s ease-in;
  }
  .hero-founder:last-of-type() {
    margin-bottom: 0;
  }

  .founder-heading {
    color: #32364e;
    font-size: 2.5rem;
  }

  .founder-avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .founder-avatar .p-avatar {
    width: 18rem;
    height: 18rem;
    border: 3px solid #32364e;
  }

  .main-side {
    padding: 2rem;
    
    line-height: 1.6;
    
    max-width: 100rem;
    font-size:6rem;
    margin-left:3rem;
   
  }

  .section-header {
    text-align: center;
  }

  .founder-description {
    padding: 2rem;
    border-radius: 25px;
    line-height: 1.6;
    color: #333;
    max-width: 100rem;
    background: #fff;
    box-shadow: 0 0 2.4rem hsl(231deg 22% 25% / 20%);
  }

  .ceo-founder .founder-avatar {
    /*margin-right: 6rem;*/
  }
  
  .hidden-founder.cto-founder {
    transform: translateX(9.6rem);
  }

  .cto-founder {
    flex-direction: row-reverse;
  }
  
  .cto-founder .founder-avatar {
    margin-left: 6rem;
  }

   .heading-primary {
      font-size: 4rem;
      text-align: center;
    }

  .heading-secondary {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .signup-free{
   
    margin-bottom: 1rem;
  }

button {
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s;
  padding: 10px 20px;
  border-radius: 0.8rem;
  background-image: linear-gradient(
    to right,
    rgb(105, 59, 245, 1),
    rgb(105, 59, 245, 0.85),
    rgb(105, 59, 245, 0.7)
  );
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 2rem;
  max-width: fit-content;
}

button:hover {
  box-shadow: 0 0.4rem 3.2rem rgb(105, 59, 245, 0.6);
  transform: scale(1.05);
}

button > svg {
  width: 3.6rem;
  margin-left: 1rem;
  transition: transform 0.3s ease-in-out;
  font-weight: 700;
}

button:hover svg {
  transform: translateX(5px);
}

button:active {
  transform: scale(0.95);
}



  /* **************************** */
  /* BELOW 1360px (Small desktop/laptop) */
  /* **************************** */
  @media (max-width: 85em) {
    .hero-content {
        max-width: 150rem;
    }
  
    .heading-primary {
      font-size: 4rem;
    }

    .founder-description {
        max-width: 75rem;
    }

    .main-side {
      max-width: 75rem;
    }
  }
  
  /* **************************** */
  /* BELOW 976px (landscape tablets) */
  /* **************************** */
  @media (max-width: 61em) {
    .hero-content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .hero-founder {
        flex-direction: column;
        justify-content: center;
    }

    .founder-avatar {
        margin: 0 6rem 0;
    }

    .founder-description,
    .cto-founder .founder-description  {
        text-align: center;
        max-width: 90rem;
    }

    .main-side {
      text-align: center;
      max-width: 50rem;
      align-items: center;
      justify-content: center;
      display:flex;
      flex-direction: column;

    }
    .grid--2-cols {
         grid-template-columns: 1fr;
    }

    .custom-text {
      padding-bottom:0;
    }

    .custom-course-img{
      max-width:35rem;
    }
           
    .heading-primary {
      font-size: 3.6rem;
    }

    .heading-secondary {
      margin-bottom: 1rem;
    }
    /*
    .heading-course-cat {
      margin-bottom: 2.8rem;
    }*/

    .container{
      max-width: 100%;
      padding: 0;
    }

    .main-section{
      padding-left: 0;
    }
  }
  
  /* **************************** */
  /* BELOW 800px (tablet) */
  /* **************************** */
  @media (max-width: 50em) {
  }
  
  /* **************************** */
  /* BELOW 592px (mobile) */
  /* **************************** */
  @media (max-width: 37em) {
    .course-desc-cont{
      flex-grow: 0;
    }
    .course-box{
      flex-direction:column;
    }
    .heading-primary {
      font-size: 3rem;
    }

    .founder-heading {
        font-size: 2rem;
    }

    .founder-avatar .p-avatar {
        width: 15rem;
        height: 15rem;
    }

    .founder-description {
        padding: 1.2rem;
        font-size: 1.8rem;
        border-radius: 10px;
    }

    .main-side {
      font-size: 3rem;
      margin-left: 0;
    }
  }
  
  /* **************************** */
  /* BELOW 496px (mobile) */
  /* **************************** */
  @media (max-width: 31em) {
    .heading-primary {
      font-size: 2.4rem;
    }

    .heading-secondary {
      margin-bottom: 1rem;
    }

     button {
      padding: 8px 16px;
    }
  }

  /*** Grid */

  ::v-deep(.grid) {
    display: flex !important;
    flex-wrap: wrap;
    margin-left: -.5rem;
    margin-right: -.5rem;
    margin-top: -.5rem;
    column-gap: unset;
    row-gap: 4rem;
}

::v-deep(.grid>.col,.grid>[class*=col]) {
    box-sizing: border-box
}

::v-deep(.grid-nogutter) {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0
}

::v-deep(.grid-nogutter>.col,.grid-nogutter>[class*=col-]) {
    padding: 0
}

::v-deep(.p2){
  padding: .5rem !important;
}

::v-deep(.col) {
    flex-basis: 0;
    flex-grow: 1;
    padding: .5rem
}

::v-deep(.col-1,.col-fixed) {
    flex: 0 0 auto;
    padding: .5rem
}

::v-deep(.col-1) {
    width: 8.3333%
}

::v-deep(.col-2) {
    width: 16.6667%
}

::v-deep(.col-2,.col-3) {
    flex: 0 0 auto;
    padding: .5rem
}

::v-deep(.col-3) {
    width: 25%
}

::v-deep(.col-4) {
    width: 33.3333%
}

.col-4,.col-5 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-5 {
    width: 41.6667%
}

.col-6 {
    width: 50%
}

.col-6,.col-7 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-7 {
    width: 58.3333%
}

.col-8 {
    width: 66.6667%
}

.col-8,.col-9 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-9 {
    width: 75%
}

.col-10 {
    width: 83.3333%
}

.col-10,.col-11 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-11 {
    width: 91.6667%
}

::v-deep(.col-12) {
    flex: 0 0 auto;
    padding: .5rem;
    width: 100%
}

@media screen and (min-width: 576px) {
    .sm\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .sm\:col-1,.sm\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-1 {
        width: 8.3333%
    }

    .sm\:col-2 {
        width: 16.6667%
    }

    .sm\:col-2,.sm\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-3 {
        width: 25%
    }

    .sm\:col-4 {
        width: 33.3333%
    }

    .sm\:col-4,.sm\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-5 {
        width: 41.6667%
    }

    ::v-deep(.sm\:col-6) {
        width: 50%
    }

    ::v-deep(.sm\:col-6,.sm\:col-7) {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-7 {
        width: 58.3333%
    }

    .sm\:col-8 {
        width: 66.6667%
    }

    .sm\:col-8,.sm\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-9 {
        width: 75%
    }

    .sm\:col-10 {
        width: 83.3333%
    }

    .sm\:col-10,.sm\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-11 {
        width: 91.6667%
    }

    .sm\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 768px) {
    .md\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .md\:col-1,.md\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-1 {
        width: 8.3333%
    }

    .md\:col-2 {
        width: 16.6667%
    }

    .md\:col-2,.md\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-3 {
        width: 25%
    }

    ::v-deep(.md\:col-4) {
        width: 33.3333%
    }

    ::v-deep(.md\:col-4,.md\:col-5 ){
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-5 {
        width: 41.6667%
    }

    .md\:col-6 {
        width: 50%
    }

    .md\:col-6,.md\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-7 {
        width: 58.3333%
    }

    .md\:col-8 {
        width: 66.6667%
    }

    .md\:col-8,.md\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-9 {
        width: 75%
    }

    .md\:col-10 {
        width: 83.3333%
    }

    .md\:col-10,.md\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-11 {
        width: 91.6667%
    }

    .md\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 992px) {
    .lg\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .lg\:col-1,.lg\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-1 {
        width: 8.3333%
    }

    .lg\:col-2 {
        width: 16.6667%
    }

    .lg\:col-2,.lg\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-3 {
        width: 25%
    }

    .lg\:col-4 {
        width: 33.3333%
    }

    .lg\:col-4,.lg\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-5 {
        width: 41.6667%
    }

    .lg\:col-6 {
        width: 50%
    }

    .lg\:col-6,.lg\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-7 {
        width: 58.3333%
    }

    .lg\:col-8 {
        width: 66.6667%
    }

    .lg\:col-8,.lg\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-9 {
        width: 75%
    }

    .lg\:col-10 {
        width: 83.3333%
    }

    .lg\:col-10,.lg\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-11 {
        width: 91.6667%
    }

    .lg\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 1200px) {
    ::v-deep(.xl\:col) {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .xl\:col-1,.xl\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-1 {
        width: 8.3333%
    }

    .xl\:col-2 {
        width: 16.6667%
    }

    .xl\:col-2,.xl\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-3 {
        width: 25%
    }

    .xl\:col-4 {
        width: 33.3333%
    }

    .xl\:col-4,.xl\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-5 {
        width: 41.6667%
    }

    .xl\:col-6 {
        width: 50%
    }

    .xl\:col-6,.xl\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-7 {
        width: 58.3333%
    }

    .xl\:col-8 {
        width: 66.6667%
    }

    .xl\:col-8,.xl\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-9 {
        width: 75%
    }

    .xl\:col-10 {
        width: 83.3333%
    }

    .xl\:col-10,.xl\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-11 {
        width: 91.6667%
    }

    .xl\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

.col-offset-0 {
    margin-left: 0!important
}

.col-offset-1 {
    margin-left: 8.3333%!important
}

.col-offset-2 {
    margin-left: 16.6667%!important
}

.col-offset-3 {
    margin-left: 25%!important
}

.col-offset-4 {
    margin-left: 33.3333%!important
}

.col-offset-5 {
    margin-left: 41.6667%!important
}

.col-offset-6 {
    margin-left: 50%!important
}

.col-offset-7 {
    margin-left: 58.3333%!important
}

.col-offset-8 {
    margin-left: 66.6667%!important
}

.col-offset-9 {
    margin-left: 75%!important
}

.col-offset-10 {
    margin-left: 83.3333%!important
}

.col-offset-11 {
    margin-left: 91.6667%!important
}

.col-offset-12 {
    margin-left: 100%!important
}

@media screen and (min-width: 576px) {
    .sm\:col-offset-0 {
        margin-left:0!important
    }

    .sm\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .sm\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .sm\:col-offset-3 {
        margin-left: 25%!important
    }

    .sm\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .sm\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .sm\:col-offset-6 {
        margin-left: 50%!important
    }

    .sm\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .sm\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .sm\:col-offset-9 {
        margin-left: 75%!important
    }

    .sm\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .sm\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .sm\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 768px) {
    .md\:col-offset-0 {
        margin-left:0!important
    }

    .md\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .md\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .md\:col-offset-3 {
        margin-left: 25%!important
    }

    .md\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .md\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .md\:col-offset-6 {
        margin-left: 50%!important
    }

    .md\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .md\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .md\:col-offset-9 {
        margin-left: 75%!important
    }

    .md\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .md\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .md\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 992px) {
    .lg\:col-offset-0 {
        margin-left:0!important
    }

    .lg\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .lg\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .lg\:col-offset-3 {
        margin-left: 25%!important
    }

    .lg\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .lg\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .lg\:col-offset-6 {
        margin-left: 50%!important
    }

    .lg\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .lg\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .lg\:col-offset-9 {
        margin-left: 75%!important
    }

    .lg\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .lg\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .lg\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 1200px) {
    .xl\:col-offset-0 {
        margin-left:0!important
    }

    .xl\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .xl\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .xl\:col-offset-3 {
        margin-left: 25%!important
    }

    .xl\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .xl\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .xl\:col-offset-6 {
        margin-left: 50%!important
    }

    .xl\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .xl\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .xl\:col-offset-9 {
        margin-left: 75%!important
    }

    .xl\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .xl\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .xl\:col-offset-12 {
        margin-left: 100%!important
    }
}
.relative {
    position: relative !important;
}
.mx-auto {
    /*margin-left: auto !important; */
    /* margin-right: auto !important; */
}
  </style>
  